var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "c-message c-message--centered c-message--margins" },
    [
      _c(
        "svg",
        {
          staticClass: "c-message__icon c-message__icon--medium",
          attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512" }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M25.8,251.5c-5.1,4.2-5.8,11.8-1.6,16.9c0,0,0,0,0,0l25.5,31c4.2,5.1,11.8,5.9,16.9,1.6c0,0,0,0,0,0l99.4-81.9L114,178.9\n      L25.8,251.5z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M357.5,368v95.6c0,8.8,7.1,16,15.9,16c0,0,0,0,0.1,0l112,0.3c4.6,0,8.7-1.9,11.6-5L357.4,367\n      C357.4,367.4,357.5,367.7,357.5,368z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M117.5,300.1V464c0,8.8,7.2,16,16,16l112.1-0.3c8.8,0,15.9-7.2,15.9-16V368c0-8.8,7.2-16,16-16H338L191.7,239L117.5,300.1z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M633.8,458.1L501.5,355.8V300L317.2,148.3c-4.5-3.6-10.8-3.6-15.3,0h0l-33.4,27.5l-25.7-19.8l59.1-48.6\n      c4.5-3.6,10.8-3.6,15.3,0L552.4,301c5.1,4.2,12.7,3.5,16.9-1.6c0,0,0,0,0,0l25.5-31c4.2-5.1,3.5-12.7-1.7-16.9c0,0,0,0,0,0h0\n      l-83.6-68.9V44.1c0-6.6-5.4-12-12-12h-56c-6.6,0-12,5.4-12,12v72.6L340,43c-17.7-14.6-43.3-14.6-61,0l-88.2,72.7L45.5,3.4\n      c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.4l588.4,454.7h0c7,5.4,17,4.2,22.5-2.8l19.6-25.3\n      C642,473.6,640.8,463.5,633.8,458.1z"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Vi har ingen boliger som passer med dine valg. Prøv å endre dine filtreringsvalg for nye resultater."
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }